/** Shared spellings for broker work areas in Surat. Add new areas here as needed. */
export const BROKER_WORK_AREAS = [
  'Adajan', 'Althan', 'Amroli', 'Athwa', 'Bardoli', 'Bhatar', 'Bhestan',
  'City Light', 'Dandi Road', 'Dindoli', 'Dumas Road', 'Ghod Dod Road',
  'Godadara', 'Hazira', 'Jahangirabad', 'Jahangirpura', 'Kadodara',
  'Katargam', 'Kosad', 'Magdalla', 'Mota Varachha', 'Nanpura', 'Olpad',
  'Pal', 'Palanpur', 'Palanpur Canal', 'Palanpore', 'Parvat Patiya',
  'Piplod', 'Rander', 'Sachin', 'Saroli', 'Sarthana', 'Udhna',
  'Ugat Canal Road', 'Varachha', 'Vanakla', 'Vesu', 'VIP Road', 'Yogi Chowk',
] as const;

export const parseBrokerAreas = (value: string): string[] => {
  const seen = new Set<string>();
  return value.split(',').map((area) => area.trim()).filter((area) => {
    const key = area.toLocaleLowerCase();
    if (!area || seen.has(key)) return false;
    seen.add(key);
    return true;
  });
};
